import { render } from "./MissedList.vue?vue&type=template&id=965c3e42"
import script from "./MissedList.vue?vue&type=script&lang=js"
export * from "./MissedList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__